export var translations = {
    'en': {
        'just_now': 'just now',
        'seconds_ago': ' sec ago',
        'minutes_ago': ' min ago',
        'today': 'Today ',
        'yesterday': 'Yesterday '
    },
    'ru': {
        'just_now': 'прямо сейчас',
        'seconds_ago': ' сек. назад',
        'minutes_ago': ' мин. назад',
        'today': 'Сегодня ',
        'yesterday': 'Вчера '
    },
    'es': {
        'just_now': 'justo ahora',
        'seconds_ago': 'seg. atrás',
        'minutes_ago': 'min. atrás',
        'today': 'Hoy ',
        'yesterday': 'Ayer '
    },
    'kk': {
        'just_now': 'дәл қазір',
        'seconds_ago': 'сек. бұрын',
        'minutes_ago': 'мин. бұрын',
        'today': 'Бүгін',
        'yesterday': 'Кеше'
    },
    'uz': {
        'just_now': 'hozir',
        'seconds_ago': 'soniya oldin',
        'minutes_ago': 'daqiq oldin',
        'today': 'Bugun ',
        'yesterday': 'Kecha '
    },
    'de': {
        'just_now': 'gerade eben',
        'seconds_ago': ' Sek. her',
        'minutes_ago': ' Min. her',
        'today': 'Heute ',
        'yesterday': 'Gestern '
    },
    'fr': {
        'just_now': 'À l\'instant',
        'seconds_ago': ' s. avant',
        'minutes_ago': ' min. avant',
        'today': 'Aujourd\'hui ',
        'yesterday': 'Hier '
    },
    'it': {
        'just_now': 'proprio ora',
        'seconds_ago': ' sec. fa',
        'minutes_ago': ' min. fa',
        'today': 'Oggi',
        'yesterday': 'Ieri'
    }
};
